import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/BreakingNewsBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/FearGreedGauge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/FooterBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/HeroCandlestickChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/MarketOverviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/MarketTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/NewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/NewsletterWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u453023306/domains/digitalmoney.tv/hbuilds/source/src/app/components/TopNav.tsx");
